import * as yup from 'yup'
import { isPatientRN } from 'presentation/utils/validators/is-patient-rn'

const ValidationSchema = yup.object().shape({
  birthday: yup
    .date()
    .typeError('Data inválida')
    .max(
      new Date(),
      'Data futura não permitida. Escolha uma data igual ou anterior à data atual'
    )
    .format('DD/MM/YYYY', true)
    .required(),
  name: yup.string().required(),
  cpf: yup.string().cpf().required(),
  gender: yup.string().required(),
  marital_status: yup.string().when('birthday', {
    is: (date: any) => !isPatientRN(date),
    then: yup.string().required()
  }),
  email: yup.string().email().required(),
  phone: yup
    .string()
    .required('O celular é obrigatório')
    .transform((value) => value.replace(/\D/g, '')) // remove máscara
    .matches(
      /^\d{4}9\d{8}$/,
      'O telefone deve estar no formato correto com DDI + DDD + número iniciando com 9'
    ),
  health_insurance: yup.string().required()
})

export default ValidationSchema
